// extracted by mini-css-extract-plugin
var _1 = "Information__double--ZiYl9 Information__input--iTxsv generalCheckout__input--T3zx1";
var _2 = "Information__input--iTxsv generalCheckout__input--T3zx1";
var _3 = "Information__inputs--gl93u";
var _4 = "Information__main--J7BXa";
var _5 = "Information__row--iXCYY";
var _6 = "Information__section--Ewu1w OfficeGeneral__robotoSlab--GdBSw OfficeGeneral__robotoMedium--itFSf CoreGeneral__robotoMedium--xrjYk";
var _7 = "Information__single--Ttb6w Information__input--iTxsv generalCheckout__input--T3zx1";
export { _1 as "double", _2 as "input", _3 as "inputs", _4 as "main", _5 as "row", _6 as "section", _7 as "single" }
